module.exports = __webpack_public_path__ + "img/nf1图标-2.f966e4fc.png";